import { useMutationWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import { UseMutationOptions, useQueryClient } from 'react-query';
import http from '../config/http-service';
import type { MergeMasterProductPayload, MergeMasterProductResult } from './types';
import { masterProductsEndpoint } from './use-get-master-products-api';

type TData = MergeMasterProductResult;
type TError = AxiosError;
type TVariables = MergeMasterProductPayload;

type Options = Omit<UseMutationOptions<TData, TError, TVariables>, 'mutationFn'>;
type TReturnType = ReturnType<typeof useMutationWrapper<TData, TError, TVariables>>;

// POST ums/v1/cms/master-products/:loserId/merge
export function useMergeMasterProductApi(options?: Options): TReturnType {
  const queryClient = useQueryClient();
  const { onSuccess: userOnSuccess, ...restOptions } = options || {};

  const mutationFn = async ({ loserId, survivorId, collisions }: TVariables): Promise<TData> => {
    const { data } = await http.post(`${masterProductsEndpoint}/${loserId}/merge`, { survivorId, collisions });
    return data?.data ?? data;
  };

  return useMutationWrapper(mutationFn, {
    mutationKey: [`${masterProductsEndpoint}/merge`],
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries([masterProductsEndpoint]);
      userOnSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
}
